"use client";

import { useEffect } from "react";
import { sbBlok } from "@/types/sb-types";
import clsx from "clsx";

const SocialMediaWidget = ({ blok }: sbBlok) => {
  useEffect(() => {
    // Load Curator.io script
    const script = document.createElement("script");
    script.src =
      "https://cdn.curator.io/published/b35c31d4-b9b9-4ed0-b3e9-09c31ab4e905.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div
      className={clsx("grid-container", {
        "pt-7 lg:pt-14":
          !!blok.spacing_top?.length && blok.spacing_top[0].option === "large",
        "pt-14 lg:pt-[120px]":
          !!blok.spacing_top?.length &&
          blok.spacing_top[0].option === "x_large",
        "pt-[120px] lg:pt-[180px]":
          !!blok.spacing_top?.length &&
          blok.spacing_top[0].option === "xx_large",
        "pb-7 lg:pb-14":
          !!blok.spacing_bottom?.length &&
          blok.spacing_bottom[0].option === "large",
        "pb-14 lg:pb-[120px]":
          !!blok.spacing_bottom?.length &&
          blok.spacing_bottom[0].option === "x_large",
        "pb-[120px] lg:pb-[180px]":
          !!blok.spacing_bottom?.length &&
          blok.spacing_bottom[0].option === "xx_large",
      })}
    >
      <div className="col-start-1 col-span-4 lg:col-start-2 lg:col-span-14 2xl:col-start-4 2xl:col-span-26">
        <div id="curator-feed-mentions-and-tags-layout" />
      </div>
    </div>
  );
};

export default SocialMediaWidget;
